<div [formGroup]="formSearch">
  <div class="flex gap-3 mb-3">
    <mat-form-field class="w-3/12 input-tg px-2" appearance="outline">
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome" />
    </mat-form-field>

    <mat-form-field class="w-3/12 input-tg px-2" appearance="outline">
      <mat-label>Documento</mat-label>
      <input matInput formControlName="documento" />
    </mat-form-field>

    <mat-form-field class="w-3/12 input-tg px-2" appearance="outline">
      <mat-label>Contato</mat-label>
      <input matInput formControlName="contato" />
    </mat-form-field>

    <mat-form-field class="w-3/12 input-tg px-2" appearance="outline">
      <mat-label>CPF</mat-label>
      <input matInput formControlName="cpf" />
    </mat-form-field>
  </div>
  <div class="flex gap-3 mb-3">
    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Tipo Trecho</mat-label>
      <mat-select formControlName="tipoTrecho">
        <mat-option *ngFor="let item of tipoTrechoList" [value]="item.id">
          {{ item.descricao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Destino / Origem Voo</mat-label>
      <input matInput formControlName="destinoOrigemVoo" />
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Data</mat-label>
      <input
        matInput
        [matDatepicker]="pickerData"
        formControlName="data"
        readonly
      />
      <mat-datepicker-toggle matIconSuffix [for]="pickerData"></mat-datepicker-toggle>
      <mat-datepicker #pickerData></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Data do Voo</mat-label>
      <input
        matInput
        [matDatepicker]="pickerVooData"
        formControlName="vooData"
        readonly
      />
      <mat-datepicker-toggle matIconSuffix [for]="pickerVooData"></mat-datepicker-toggle>
      <mat-datepicker #pickerVooData></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Companhia</mat-label>
      <input matInput formControlName="companhia" />
    </mat-form-field>

    <mat-form-field class="w-1/12 input-tg px-2" appearance="outline">
      <mat-label>Voo</mat-label>
      <input matInput formControlName="voo" />
    </mat-form-field>
  </div>


  <div class="flex gap-3 mb-3 items-center flex-wrap">
    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Origem Tipo</mat-label>
      <mat-select formControlName="origemTipo">
        <mat-option [value]="null">Todos</mat-option>
        <mat-option *ngFor="let opt of tipoLocalOptions" [value]="opt.value">
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Origem Cidade</mat-label>
      <input matInput formControlName="origemCidade" />
    </mat-form-field>

    @if (formSearch.get('origemTipo')?.value === 'AEROPORTO') {
      <mat-form-field class="w-1/12 input-tg px-2" appearance="outline">
        <mat-label>Origem Sigla</mat-label>
        <input matInput formControlName="origemAeroSigla" />
      </mat-form-field>
    }

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Destino Tipo</mat-label>
      <mat-select formControlName="destinoTipo">
        <mat-option [value]="null">Todos</mat-option>
        <mat-option *ngFor="let opt of tipoLocalOptions" [value]="opt.value">
          {{ opt.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="w-2/12 input-tg px-2" appearance="outline">
      <mat-label>Destino Cidade</mat-label>
      <input matInput formControlName="destinoCidade" />
    </mat-form-field>

    @if (formSearch.get('destinoTipo')?.value === 'AEROPORTO') {
      <mat-form-field class="w-1/12 input-tg px-2" appearance="outline">
        <mat-label>Destino Sigla</mat-label>
        <input matInput formControlName="destinoAeroSigla" />
      </mat-form-field>
    }

    <div class="flex flex-col gap-1 px-2">
      <mat-checkbox formControlName="apenasComVoo">Apenas com voo</mat-checkbox>
      <mat-checkbox formControlName="apenasSeVoo">Apenas sem voo</mat-checkbox>
    </div>
  </div>

  <div class="mb-3 flex w-full justify-end items-center gap-2">
    <button
      class="btn-icon"
      (click)="sendSearch(false)"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
